import { ColDef } from '@ag-grid-community/core';

export const columnDefs: ColDef[] = [
  { headerName: 'User ID', field: 'nameid', lockVisible: true, lockPosition: true, cellStyle: { textAlign: 'center' } },
  { headerName: 'User Name', field: 'username', cellStyle: { textAlign: 'center' } },
  { headerName: 'Facility', field: 'facility', cellStyle: { textAlign: 'center' } },
  { headerName: 'Group', field: 'groupid', cellStyle: { textAlign: 'center' } },
  { headerName: 'Status', field: 'userstatus', cellStyle: { textAlign: 'center' } },
];

export const defColumnPreferences = [
  { colId: 'nameid', hide: false, aggFunc: null, width: 200, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'username', hide: false, aggFunc: null, width: 200, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'facility', hide: false, aggFunc: null, width: 150, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'groupid', hide: false, aggFunc: null, width: 150, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'userstatus', hide: false, aggFunc: null, width: 150, pivotIndex: null, pinned: null, rowGroupIndex: null },
];
